/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 企業の管理画面用 API
 * PR TIMES 企業の管理画面で使うAPI。basePathは今後変わる事も想定している。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PrtimesMediaOutlet } from './PrtimesMediaOutlet';
import {
    PrtimesMediaOutletFromJSON,
    PrtimesMediaOutletFromJSONTyped,
    PrtimesMediaOutletToJSON,
} from './PrtimesMediaOutlet';

/**
 * 自社メディアリストのメディア一覧を返すレスポンス
 * @export
 * @interface GetPrtimesMediaListMediaOutletsResponse
 */
export interface GetPrtimesMediaListMediaOutletsResponse {
    /**
     * 自社メディアリストに含まれるメディアの総数（fieldsで指定された時だけ）
     * @type {number}
     * @memberof GetPrtimesMediaListMediaOutletsResponse
     */
    totalCount?: number;
    /**
     * 指定範囲のメディア一覧
     * @type {Array<PrtimesMediaOutlet>}
     * @memberof GetPrtimesMediaListMediaOutletsResponse
     */
    prtimesMediaOutlets: Array<PrtimesMediaOutlet>;
}

/**
 * Check if a given object implements the GetPrtimesMediaListMediaOutletsResponse interface.
 */
export function instanceOfGetPrtimesMediaListMediaOutletsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "prtimesMediaOutlets" in value;

    return isInstance;
}

export function GetPrtimesMediaListMediaOutletsResponseFromJSON(json: any): GetPrtimesMediaListMediaOutletsResponse {
    return GetPrtimesMediaListMediaOutletsResponseFromJSONTyped(json, false);
}

export function GetPrtimesMediaListMediaOutletsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPrtimesMediaListMediaOutletsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'total_count') ? undefined : json['total_count'],
        'prtimesMediaOutlets': ((json['prtimes_media_outlets'] as Array<any>).map(PrtimesMediaOutletFromJSON)),
    };
}

export function GetPrtimesMediaListMediaOutletsResponseToJSON(value?: GetPrtimesMediaListMediaOutletsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_count': value.totalCount,
        'prtimes_media_outlets': ((value.prtimesMediaOutlets as Array<any>).map(PrtimesMediaOutletToJSON)),
    };
}

